import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Calendar, Leaf, Award, User, MapPin } from "lucide-react";

const items = [
  { path: "/dashboard", label: "Home", icon: Home },
  { path: "/calendar", label: "Calendar", icon: Calendar },
  { path: "/lifestyle", label: "Track", icon: Leaf },
  { path: "/carepass", label: "CarePass", icon: MapPin },
  { path: "/rewards", label: "Rewards", icon: Award },
  { path: "/profile", label: "Profile", icon: User },
];

export const MobileNav = () => {
  const location = useLocation();
  return (
    <nav className="mobile-nav md:hidden" data-testid="mobile-nav">
      {items.map((item) => {
        const isActive = location.pathname === item.path;
        const Icon = item.icon;
        return (
          <Link
            key={item.path}
            to={item.path}
            className={`mobile-nav-item ${isActive ? 'active' : ''}`}
            data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            style={{ minHeight: 48 }}
          >
            <Icon className="w-5 h-5" strokeWidth={1.5} />
            <span className="text-[10px] mt-1">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default MobileNav;
